import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import Paper from "material-ui-next/Paper";
import LinearProgress from "material-ui-next/Progress/LinearProgress";

class ProgressView extends Component {
  render() {
    const { progress } = this.props;

    return (
      <Paper elevation={1} className="full-width mb-md">
        <LinearProgress mode="determinate" value={parseInt(progress, 10)} />
        <Row center="xs" middle="xs" className="mt-sm">
          <Col xs>
            <Typography type="title" className="pb-sm">
              Existe uma importação em andamento.
            </Typography>
            <Typography type="subheading" className="pb-sm">
              A importação atual está em {progress}%
            </Typography>
            <Typography type="subheading" className="pb-sm">
              Será possível fazer uma nova importação após a atual terminar.
            </Typography>
          </Col>
        </Row>
      </Paper>
    );
  }
}

export default ProgressView;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/xml/progress/index.js